var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlignMiddleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v34H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#545454"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 11.75H27v9.5h-7.5v-9.5zM9 7.75h7.5v17.5H9V7.75z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 7.75v17.5H9V7.75h7.5zm3 4H27v9.5h-7.5v-9.5zM15 9.25h-4.5v14.5H15V9.25zm10.5 4H21v6.5h4.5v-6.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 15.5h2.5v2H27v-2zm-10.5 0h3v2h-3v-2zm-7.5 2H6.5v-2H9v2z",
  opacity: 0.65
})))));
export default SvgAlignMiddleIcon;